import Vue from 'vue';
import Router from 'vue-router';
import MyTrains from './views/MyTrains.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'הרכבת שלי',
      component: MyTrains
    },
    {
      path: '/search',
      name: 'חיפוש',
      component: () => import(/* webpackChunkName: "search" */ './views/Search.vue')
    },
    {
      path: '/search-results',
      name: 'תוצאות חיפוש',
      component: () => import(/* webpackChunkName: "search-results" */ './views/SearchResults.vue')
    }
  ]
});
